import store from '@/store'

export default {
	install: (app, options) => {
		app.config.globalProperties.$translate = key => {
			return key.split('.').reduce((o, i) => {
				if (o) return o[i]
			}, options)
		}
		app.mixin({
			data() {
				return {
					screen: ''
				}
			},
			methods: {
				scrollTo(anchor, offset = 0) {
					const element = document.getElementById(anchor)
					window.scrollTo({
						behavior: 'smooth',
						top: element.offsetTop + offset
					})
				},
				getBankAdress(bank = 'Hyundai Capital Bank Europe') {
					if (bank === 'ALLANE SE') {
						return 'Allane SE, Dr.-Carl-von-Linde-Straße 2, 82049 Pullach'
					} else {
						// Santander Bank
						// return 'FCA Bank Deutschland, ein Geschäftsbereich der FCA Bank Deutschland GmbH, Salzstraße 138, 74076 Heilbronn'
						return 'Santander Bank, ein Geschäftsbereich der Santander Consumer Bank AG, Santander-Platz 1, 41061 Mönchengladbach'
					}
				},
				getLegalTextFinanceFilter(show = false) {
					const legalText =
						'Basierend auf einer beispielhaften und unverbindlichen Kalkulation mit ' +
						'60 Monaten Laufzeit, 10.000 Km Laufleistung jährlich und Anzahlung in Höhe von ' +
						'20% des Fahrzeugpreises. Zusätzlich zu den Monatsraten kann ggf. noch ' +
						'eine Schlussrate anfallen, deren Höhe vom jeweiligen Fahrzeug abhängt.'
					return show ? legalText : legalText.slice(0, 100) + '...'
				},
				getLegalTextLeasingFilter(show = false) {
					const legalText =
						'Basierend auf einer beispielhaften und unverbindlichen ' +
						'Leasingkalkulation mit 48 Monaten Laufzeit, 10.000 Km Laufleistung jährlich und ' +
						'einer Sonderzahlung in Höhe von 20% des Fahrzeugpreises.'
					return show ? legalText : legalText.slice(0, 100) + '...'
				},
				getLegalTextFinanceDetails(bank = 'Hyundai Capital Bank Europe') {
					return (
						'Alle Finanzierungsraten sind unverbindliche beispielhafte ' +
						'Finanzierungskalkulationen der ' +
						this.getBankAdress(bank) +
						'. Hierbei handelt es ' +
						'sich gleichzeitig um das repräsentative Beispiel gem. §6aPAngV. Bonität ' +
						'vorausgesetzt. Alle Preise inkl. gesetzlicher MwSt. Änderungen und ' +
						'Irrtümer vorbehalten.'
					)
				},
				getLegalTextLeasingDetails(downPayment, bank) {
					if (bank === 'ALLANE SE') {
						return (
							'Ein unverbindliches Leasingbeispiel der ALLANE SE, ' +
							'Dr.-Carl-von-Linde-Straße 2, 82049 Pullach. Dieses Angebot ' +
							'erfordert eine Sonderzahlung in Höhe von ' +
							this.getPrice(downPayment) +
							' € (brutto). Alle Preise inkl. ' +
							'gesetzlicher MwSt. Änderungen und Irrtümer vorbehalten.'
						)
					} else {
						return (
							'Ein unverbindliches Leasingbeispiel der HYUNDAI Finance, ein ' +
							'Geschäftsbereich der Hyundai Capital Bank Europe GmbH, ' +
							'Friedrich-Ebert-Anlage 35–37, 60327 Frankfurt am Main. Dieses Angebot ' +
							'erfordert eine Sonderzahlung in Höhe von ' +
							this.getPrice(downPayment) +
							' € (brutto). Alle Preise inkl. ' +
							'gesetzlicher MwSt. Änderungen und Irrtümer vorbehalten.'
						)
					}
				},
				whatsappOnline() {
					// Sa. ab 17 Uhr bis Mo morgen 7
					const date = new Date()
					if (date.getDay() === 6 && date.getHours() > 16) {
						return false
					} else if (date.getDay() === 1 && date.getHours() < 8) {
						return false
					} else if (date.getDay() === 7) {
						return false
					} else {
						return true
					}
				},

				// DD-Castrop
				// https://wa.me/4923232283266?text=%5BNachfrage+zu%3A7%5D+ K%C3%B6nnen+Sie+mich+bitte+kontaktieren%3F
				// DD-Datteln
				// https://wa.me/4923232283266?text=%5BNachfrage+zu%3A8%5D+ K%C3%B6nnen+Sie+mich+bitte+kontaktieren%3F
				getWhatsAppLink(car, price, title) {
					console.log('car.store.alias:: ', car.store.alias)

					let text = ''

					// @habamedia
					// TODO New whatsapp catch integration - add other stores
					if (car.store.alias === 'dd-castrop') {
						text = 'https://wa.me/4923232283266?text=%5BNachfrage+zu%3A7%5D+'
						text += encodeURIComponent(title) + '%0a'
					} else if (
						car.store.alias === 'fca-datteln' ||
						car.store.alias === 'dd-datteln'
					) {
						text = 'https://wa.me/4923232283266?text=%5BNachfrage+zu%3A8%5D+'
						text += encodeURIComponent(title) + '%0a'
					} else {
						text = 'https://api.whatsapp.com/send?phone=+4923232283266&text='
						text +=
							encodeURIComponent('Hallo, ich interessiere mich für: ' + title) +
							'%0a'
					}

					text += encodeURIComponent('Angebots-Nr.: ')
					text += car.ad.internalNumber
					text +=
						'%0a' +
						encodeURIComponent(
							'Kaufpreis: ' + this.getPrice(car.consumerPriceGross) + '€'
						) +
						'%0a'
					if (price.view === 'finance') {
						if (car.finance !== null) {
							text +=
								' | Finanzierungsrate: ' +
								this.getPrice(price.financing.rate) +
								'€ mtl.'
						} else {
							text += ' | Monatsrate angefragt'
						}

						text += encodeURIComponent(
							' | Laufzeit: ' +
								price.financing.period +
								' Monate | Anzahlung: ' +
								this.getPrice(price.financing.deposit) +
								' €'
						)
					} else if (this.priceView === 'leasing') {
						text += encodeURIComponent(
							'Leasingrate: ' +
								this.getPrice(price.leasing.rate) +
								' € mtl. | Laufzeit: ' +
								price.leasing.period +
								' Monate | Laufleistung: ' +
								this.getPrice(price.leasing.mileage) +
								' Km | Sonderzahlung: ' +
								this.getPrice(price.leasing.deposit) +
								' €'
						)
					}
					text += '%0aStandort: ' + car.store.title
					text += '%0aBitte kontaktieren Sie mich.'
					return text
				},
				copyToClipboard(input) {
					const element = document.getElementById(input)

					this.$toast('Link zum Fahrzeug kopiert', {
						type: 'success'
					})
					element.select()
					element.setSelectionRange(0, 99999)
					document.execCommand('copy')
				},
				addCarToBookmarks(car) {
					if (Object.keys(store.state.user.bookmarks.cars).length < 9) {
						this.$toast('Fahrzeug zur Merkliste hinzugefügt', {
							type: 'success'
						})
						store.commit('addCarToBookmarks', car)
					} else {
						this.$toast('Es können maximal 10 Fahrzeuge gespeichert werden.', {
							type: 'error'
						})
					}
				},
				removeCarFromBookmarks(carId) {
					this.$toast('Fahrzeug von Merkliste entfernt.', {
						type: 'error'
					})
					store.commit('removeCarFromBookmarks', carId)
				},
				getCarPs(power) {
					let carPs = +power * 1.36
					return carPs.toFixed(0)
				},
				getDeliveryMonth(days) {
					let month

					switch (days) {
						case 60:
							month = '2 Monate'
							break
						case 90:
							month = '3 Monate'
							break
						case 120:
							month = '4 Monate'
							break
						case 150:
							month = '5 Monate'
							break
						case 180:
							month = '6 Monate'
							break
						case 270:
							month = '9 Monate'
							break
						case 360:
							month = '12 Monate'
							break
						default:
							month = days + ' Tage'
					}

					return month
				},
				getCarPowerText(power) {
					return power + ' Kw / ' + this.getCarPs(power) + ' Ps'
				},
				getPrice(price) {
					price = Math.ceil(Number(price))
					let num_parts = price.toString().split('.')
					num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
					return num_parts.join('.')
				},
				getTaxText(car) {
					if (car.ad.price.vatRate !== undefined) {
						return Number(car.ad.price.vatRate) > 0
							? 'inkl. 19% MwSt.'
							: 'Differenzbesteuert'
					} else {
						return 'Differenzbesteuert'
					}
				},
				getTaxNumber(car) {
					if (car.ad.price.vatRate !== undefined) {
						if (Number(car.ad.price.vatRate) > 0) {
							return 1
						} else {
							return 2
						}
					} else {
						return 2
					}
				},
				getFirstRegistrationDate(date = 201807) {
					let month = date.toString().substr(4)
					let year = date.toString().substr(0, 4)
					return month + '/' + year
				},
				formatDate(date = null) {
					if (date) {
						let formatDate = new Date(date)
						let options = { day: '2-digit', month: '2-digit', year: 'numeric' }
						return formatDate.toLocaleDateString('de-DE', options)
					} else {
						return '-'
					}
				},
				formatDateTime(date) {
					if (date) {
						let formatDate = new Date(date)
						let options = {
							day: '2-digit',
							month: '2-digit',
							year: 'numeric',
							hour: '2-digit',
							minute: '2-digit'
						}
						return formatDate.toLocaleDateString('de-DE', options)
					} else {
						return '-'
					}
				},
				compareValues(key, order = 'asc') {
					return (a, b) => {
						// eslint-disable-next-line no-prototype-builtins
						if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
							// property doesn't exist on either object
							return 0
						}

						const varA =
							typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
						const varB =
							typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]

						let comparison = 0
						if (varA > varB) {
							comparison = 1
						} else if (varA < varB) {
							comparison = -1
						}
						return order === 'desc' ? comparison * -1 : comparison
					}
				}
			}
		})
	}
}
